import { FC, useState } from 'react';
import Box from '@mui/material/Box';
import MuiTabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ProductInterface } from 'ks-common';
import DOMPurify from 'dompurify';
import StrollerDescription from 'app/components/StrollerDescription';
import { RentalPricing } from '../RentalPricing';

interface Props {
  currentStrollerFromList?: ProductInterface;
}

const Tabs: FC<Props> = ({ currentStrollerFromList }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (!currentStrollerFromList) {
    return null;
  }

  const sanitizedSpecifications = {
    __html: DOMPurify.sanitize(currentStrollerFromList.Specifications || ''),
  };

  const tabs = [
    {
      label: 'Description',
      content: <StrollerDescription product={currentStrollerFromList} />,
    },
    {
      label: 'Pricing',
      content: <RentalPricing product={currentStrollerFromList} hideTite />,
    },
    {
      label: 'Features',
      content: <div dangerouslySetInnerHTML={sanitizedSpecifications} />,
    },
  ];

  // This fills the space left below the header in its bounded flex parent and
  // scrolls internally instead of growing the card off-screen. Touches are kept
  // from the overlay's swipe-to-dismiss gesture so scrolling doesn't drag the
  // modal closed; dismiss is still available by dragging the header.
  return (
    <>
      <MuiTabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        {tabs.map(tab => (
          <Tab key={tab.label} label={tab.label} sx={{ flex: 1 }} />
        ))}
      </MuiTabs>

      <Box
        onTouchStart={e => e.stopPropagation()}
        onTouchMove={e => e.stopPropagation()}
        sx={{
          flex: 1,
          minHeight: 0,
          mt: 3,
          px: 5,
          overflowY: 'auto',
          overscrollBehavior: 'contain',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {tabs[value].content}
      </Box>
    </>
  );
};

export default Tabs;
